import React from "react"
import {UseStores} from "../../../hooks/UseStores"
import "../index.scss"
import {observer} from "mobx-react-lite"
import {navigate} from "@reach/router"
import {defaultTimePeriod} from "../../../utils/utils"
import ProfileMenu from "../../../components/ProfileMenu"
import SearchInput from "../../../components/SearchInput"
import gt_brand from "../../../assets/svg/groundtruth_brand.svg"
import gt_logo from "../../../assets/svg/groundtruth_logo.svg"
import hamburger_icon from "../../../assets/svg/hamburger.svg"
import hamburger_open_icon from "../../../assets/svg/hamburger_open.svg"

const Header = ({user}) => {
  const {disStore, navStore, timePeriodStore, gtMapStore} = UseStores()

  const handleHomeNav = () => {
    if (window.location.pathname !== "/brands/discovery") {
      disStore.setGeoTimeObj({geo: disStore.geoNonePOI})
      gtMapStore.setMapObj({geo: disStore.geoNonePOI})
      timePeriodStore.setTimePeriod(defaultTimePeriod)
      navigate("/brands/discovery")
    }
  }

  return (
    <>
      <div className="app-bar" data-testid="header-container-test">
        <div className="header">
          <div className="left-section">
            <div className="hamburger-icon-div">
              <img
                src={navStore.sideNavToggle ? hamburger_open_icon : hamburger_icon}
                alt="Hamburger Icon"
                id="hamburger-icon"
                data-testid="hamburger-icon-test"
                onClick={() => navStore.setSideNavToggle(true)}
              ></img>
            </div>
            <div className="logo-div" onClick={handleHomeNav}>
              <img
                src={gt_logo}
                alt="GT Logo"
                className="gt-logo"
                data-testid="gt-logo-test"
              ></img>
            </div>
            <div className="brand-title-div" onClick={handleHomeNav}>
              <img
                src={gt_brand}
                alt="GT Brand"
                className="gt-brand"
                data-testid="gt-brand-test"
              ></img>
              <p className="dicovery-title">Discovery</p>
            </div>
          </div>
          <div className="right-section">
            <SearchInput />
            <ProfileMenu user={user} />
          </div>
        </div>
      </div>
    </>
  )
}
export default observer(Header)
